'use strict';

/* Stylesheets */
import 'font-awesome/less/font-awesome.less';
import '../sass/releases/index.scss';

import 'angular';
import 'angular-route';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-animate';

import './controllers';
import './directives';
import './services';
import './validators';
import './values';

export default angular.module('app', [
    'ngRoute',
    'ngResource',
    'ngSanitize',
    'ngAnimate',
    'app.controllers',
    'app.directives',
    'app.services',
    'app.validators',
    'app.values',
]);



// WEBPACK FOOTER //
// ./resources/assets/app-releases/app.js